import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
import BookHistoryInfo from "@/components/book/BookHistoryInfo.vue";

import { IBookInfo } from "@/domain/entities/book";
import { BookStatusName } from "@/types";


const __default__ = {
  name: "BookHistoryRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookInfo: {
    type: Object as PropType<IBookInfo>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const canceled = ref(false);
canceled.value = props.bookInfo.bookStatus === BookStatusName.CANCEL;

const expired = ref(false);
expired.value = props.bookInfo.bookStatus === BookStatusName.BOARD;

const noShow = ref(false);
noShow.value = props.bookInfo.bookStatus === BookStatusName.NOSHOW;

const __returned__ = { props, canceled, expired, noShow, BookHistoryInfo, get BookStatusName() { return BookStatusName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})